
    import {Component, Vue} from 'vue-property-decorator'
    import SearchNav from "@/views/goodsManage/mall/shop/template/SearchNav.vue";
    import GoodsResultCard from "@/views/goodsManage/mall/shop/template/GoodsResultCard.vue";
    import {getH5GoodsList, ShareGoodsListDto} from "@/api/share";
    import {isOptionalGoods} from "@/api/shoppingMall";
    import {Getter} from "vuex-class";

    @Component({
        name: 'ShareGoodsList',
        components: {SearchNav, GoodsResultCard}
    })
    export default class ShareGoodsList extends Vue {
        @Getter shareInfo!: any

        goodsList: ShareGoodsListDto[] = []
        params = {
            pageIndex: 1,
            pageSize: 20,
            shopId: '',
            keyword: ''
        }
        refreshing = false
        loading = false
        finished = false
        priceShowType = 0 // 分享商品页面价格显示类别(0:不显示价格，1:市场价)


        created () {
            this.params.shopId = this.shareInfo.shopId
            this.getGoodsList()
        }

        getGoodsList () {
            getH5GoodsList(this.params).then((res) => {
                this.refreshing = false
                // @ts-ignore
                this.priceShowType = res.data.priceShowType
                this.goodsList = res.data.records || []
                if (this.goodsList.length >= res.data.totalRecords) {
                    this.finished = true
                } else {
                    this.finished = false
                }
            }).catch(() => {
                this.refreshing = false
            })
        }

        /**
         * 下拉刷新
         * */
        onRefresh () {
            this.params.pageIndex = 1
            this.refreshing = true
            this.getGoodsList()
        }

        /**
         * 上拉加载更多
         * */
        onLoad() {
            this.params.pageIndex++
            this.loading = true
            getH5GoodsList(this.params).then((res) => {
                this.loading = false
                // @ts-ignore
                this.priceShowType = res.data.priceShowType
                this.goodsList = this.goodsList.concat(res.data.records)
                if (this.goodsList.length >= res.data.totalRecords) {
                    this.finished = true
                }
            }).catch(() => {
                this.loading = false
            })
        }

        searchFunc (keyword: string) {
            this.params.pageIndex = 1
            this.params.keyword = keyword
            this.getGoodsList()
        }

        toDetail (id: string) {
            this.$router.push({
                path: '/shareGoodsListDetail',
                query: {
                    shopId: this.params.shopId,
                    goodsId: id
                }
            })
            // isOptionalGoods(this.params).then((res) => {
            //     if (res.data.isOptional) {
            //         this.$router.push({
            //             path: '/shareGoodsListDetail',
            //             query: {
            //                 customerId: this.params.shopId, // ??
            //                 shopId: this.params.shopId,
            //                 goodsId: id
            //             }
            //         })
            //     } else {
            //         this.$dialog.alert({
            //             message: '商品过期不存在'
            //         }).then(() => {
            //             this.params.pageIndex = 1
            //             this.getGoodsList()
            //         })
            //     }
            // }).catch(() => {
            // })
        }

    }
